import { DispatchWithoutAction, useState } from "react";

import { User } from "../../../Models/User";
import { Error } from "../../../Utils/Errors";
import { useApi } from "../../../Utils/useApi";

interface UseGetUserResponse {
  /** The fully formed list of application dependencies. */
  user: User | null;
  /** Dispatches the api request. */
  execute: DispatchWithoutAction;
}

/** A hook which gets the user's identity information from the api. */
const useGetUser = (): UseGetUserResponse => {
  const [valid, setValid] = useState(false);
  const { response } = useApi<User>({ url: "Legacy/V0/User/Me", error: Error.GetUserMe, valid });

  return { user: response || null, execute: () => setValid(true) };
};

export default useGetUser;
